import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as Yup from "yup";
import {
  linkEmpList,
  linkEmployee,
} from "../../redux/actions/fieldForceAction";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";
import ChangeSaved from "../popups/ChangeSaved";
import ErrorPopup from "../popups/ErrorPopup";

const LinkEmpModal = ({
  show,
  handleClose,
  user_id,
  employee_id,
  field_force_id,
  fetchFFdetail,
}) => {
  const dispatch = useDispatch();
  const [linkEmpDataList, setLinkEmpDataList] = useState([]);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  const initialValues = {};
  const validationSchema = Yup.object().shape({});
  useEffect(() => {
    dispatch(linkEmpList(onFetchSuccess, onfetchError));
  }, []);

  const onFetchSuccess = (data) => {
    setLinkEmpDataList(data);

  };
  const onfetchError = (err) => {
    console.log(err);
  };

  const onSubmit = (values) => {
    values["field_force_id"] = field_force_id;
    dispatch(linkEmployee(values, onSuccess, onError));
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    handleClose();
    fetchFFdetail();
  }

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = (data.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  }

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    handleClose();
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName=""
      contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
    >
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="p-1">
              <p className="fn_Nunito fw_700 fs_18 my-2 px-0">
                Link to Other Employee ID
              </p>

              <div className="basic-details-container align-items-center">
                <span className="fs_14 color_747f9e">
                  <span className="text_red fw_600">Note :</span> Existed user
                  has to be disabled.
                </span>
              </div>
              <div className="my-4">
                <label className="Neutral_Color fs_14">User ID</label>
                <p className="fs_14"> {user_id}</p>
              </div>
              <div className="my-4">
                <label className="Neutral_Color fs_14">
                  Company Employee ID
                </label>
                <p className="fs_14"> {employee_id}</p>
              </div>
              <div className="my-4">
                <label className="Neutral_Color fs_14">Link With</label>
                <Field>
                  {({ form, Field }) => (
                    <Select
                      options={linkEmpDataList}
                      styles={customStyles}
                      {...Field}
                      id="linked_field_force_id"
                      name="linked_field_force_id"
                      placeholder="Select company employee ID"
                      onChange={(selectedOption) => {
                        form.setFieldValue(
                          "linked_field_force_id",
                          selectedOption.value
                        );
                      }}
                    />
                  )}
                </Field>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="modal-logout-btn fs_14 fw_700 px-4 py-2"
                  style={{ width: "130px" }}
                >
                  NO
                </button>
                <button
                  type="submit"
                  className="modal-cancel-btn fs_14 text-white py-2 px-4 fw_700"
                  style={{ width: "130px" }}
                >
                  LINK
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <ChangeSaved
          show={onSuccessShow}
          title={onSuccessMsg}
        />
        <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      </ModalBody>
    </Modal>
  );
};

export default LinkEmpModal;
export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
